import { combineReducers } from 'redux';
import { UserReducer } from './services/reducer';

export const mainModuleReducer = combineReducers({
  UserReducer,
});

export type MainModuleReducer = ReturnType<typeof mainModuleReducer>;
